import React from "react";
import Hero from "./Hero";
import Services from "./Services";
import Plans from "../booking/Plans";
import Testimonials from "./Testimonials";
import Layout from "../../components/common/Layout";
import AboutMe from "../about/AboutMe";
import { Helmet } from "react-helmet";
import Banner from "../banner/Banner";

const MainPage: React.FC = () => {
  return (
    <Layout>
      <Helmet>
        <link rel="canonical" href="https://losciclosdemarha.uy" />

        {/* Open graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://losciclosdemarha.uy" />
        <meta property="og:title" content="Los ciclos de Marha" />
        <meta
          property="og:description"
          content="Acompañamiento profesional y humano durante el embarazo, nacimiento y puerperio. Servicios personalizados para una experiencia plena y segura."
        />
        <meta
          property="og:image"
          content="https://losciclosdemarha.uy/images/marha_scanu.jpg"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:locale" content="es_UY" />
        <meta property="og:site_name" content="Los ciclos de Marha" />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://losciclosdemarha.uy" />
        <meta property="twitter:title" content="Los ciclos de Marha" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="600" />
        <meta
          property="twitter:description"
          content="Acompañamiento profesional y humano durante el embarazo, nacimiento y puerperio. Servicios personalizados para una experiencia plena y segura."
        />
        <meta
          property="twitter:image"
          content="https://losciclosdemarha.uy/images/marha_scanu.jpg"
        />
      </Helmet>
      <Hero />
      <Banner />
      <Services />
      <Plans />
      <AboutMe />
      <Testimonials />
    </Layout>
  );
};

export default MainPage;
